module.exports = __webpack_public_path__ + "img/SuperOK-2.7a948ab8.jpg";